import React from 'react';
import { ForceChangePasswordIcon } from 'common/Icons';
import { Form } from './Components/Form';

export const MobileForceChangePassword = () => {
  return (
    <div className="md:hidden  grid grid-min-one">
      <div className="mx-auto mt-5 ">
        <ForceChangePasswordIcon />
      </div>
      <div className="p-4">
        <div className="mt-4 flex flex-col justify-between h-[55vh]">
          <h1 className="text-xl font-medium text-center ">
            توجه: کاربر گرامی، رمز عبور شما منقضی شده است. لطفا برای امنیت بیشتر
            نسبت به تغییر رمز عبور خود اقدام قرمایید.
          </h1>
          <Form />
        </div>
      </div>
    </div>
  );
};
